import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from 'react-bootstrap';
import styled from 'styled-components';
import { NameCard, DropdownToggle, Icon } from 'modules/theme';
import { UserHelper } from '../styles';

const UserInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    float: none;
    margin: 0 10px;
  }
`;

const NameCardWrapper = styled.div`
  padding: 10px 20px;
`;

const NavItem = styled.div`
  padding-left: 20px;
  display: table-cell;
  vertical-align: middle;
`;

const QuickNavigation = ({ logout }, context) => {
  const currentUser = localStorage.getItem("user") || '';
  const loggedInUser = JSON.parse(currentUser).name || "Not Found";
  return (
    <nav>
      <NavItem>
        <Dropdown id="dropdown-user" pullRight>
          <DropdownToggle bsRole="toggle">
            <UserHelper>
              <UserInfo>
                {loggedInUser}
                <NameCard.Avatar user={loggedInUser} size={30} />
                <Icon icon="downarrow" size={10} />
              </UserInfo>
            </UserHelper>
          </DropdownToggle>
          <Dropdown.Menu>
            <NameCardWrapper>
              <NameCard user={loggedInUser} />
            </NameCardWrapper>
            {/* <MenuItem divider /> */}

            {/* <li>
              <Link to={`/settings/team/details/${currentUser._id}`}>
                {__('View Profile')}
              </Link>
            </li> */}

            {/* <li>
              <Link to={`/profile`}>
                {__('Profile & Accounting ')}
              </Link>
            </li> */}

            {/* <ModalTrigger
              title="Change Password"
              trigger={
                <li>
                  <a>{__('Change Password')}</a>
                </li>
              }
            >
              <ChangePassword />
            </ModalTrigger> */}
            <MenuItem divider />
            <MenuItem onClick={logout}>{'Sign out'}</MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      </NavItem>
    </nav>
  );
};

QuickNavigation.propTypes = {
  logout: PropTypes.func
};

QuickNavigation.contextTypes = {
  currentUser: PropTypes.string || PropTypes.object,
  __: PropTypes.func
};

export default QuickNavigation;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/layout/components/QuickNavigation.js